import $ from 'jquery';
import '@/js/modules/jquery_timepicker';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  let calendar;
  if ($('body').is('#calendar')) {
    document.addEventListener('DOMContentLoaded', async () => {
      // Only this page uses FullCalendar, so it stays out of the shared bundle.
      const { createCalendar } = await import('@/js/modules/full_calendar');
      const projectId = $('meta[name="project-id"]').attr('content');
      const calendarEl = document.getElementById('fullcalendar-container');
      calendar = createCalendar(calendarEl, {
        eventResizableFromStart: true,
        height: 'auto',
        timeZone: $('meta[name=time-zone]').attr('content'),
        initialView: 'dayGridMonth',
        initialDate: $('meta[name="initial-date"]').attr('content'),
        fixedWeekCount: false,
        nowIndicator: true,
        showNonCurrentDates: false,
        dayMaxEvents: 4,
        headerToolbar: {
          left: '',
          center: 'prev title next',
          right: 'today dayGridMonth,timeGridWeek,timeGridDay',
        },
        dayHeaderFormat: { weekday: 'long' },
        views: {
          dayGrid: {
            titleFormat: { year: 'numeric', month: 'long' },
          },
        },
        dateClick: (info) => {
          const params = new URLSearchParams({ date: info.dateStr, all_day: info.allDay });
          calendarEl.setAttribute(
            'data-ui--twin-turbo-modal-trigger-url-value',
            `/projects/${projectId}/calendar_events/new?${params}`
          );
          calendarEl.dispatchEvent(new CustomEvent('calendar:date-click'));
        },
        dayCellDidMount(cell) {
          const $addEventLink = $('<span class="add-calendar-event-link hide">+ Add Event</span>');
          $(cell.el).mouseenter((e) => {
            $(e.currentTarget).find('.fc-daygrid-day-top').append($addEventLink);
          });
          $(cell.el).mouseleave((e) => {
            $addEventLink.remove();
          });
          $(cell.el).mouseover((e) => {
            const $target = $(e.target);
            const $calendrEvents = $target.parents('.fc-daygrid-day-events');
            const isDayBottom = $target.hasClass('fc-daygrid-day-bottom');
            if ($target.hasClass('add-calendar-event-link')) {
              e.stopPropagation();
            }
            $addEventLink.toggle(isDayBottom || $calendrEvents.length === 0);
          });
        },
        datesSet: ({ startStr }) => {
          const newUrl = `${window.location.pathname}?start_date=${startStr.split('T')[0]}`;
          window.history.replaceState(null, '', newUrl);
        },
        eventDidMount: ({ el, event }) => {
          Object.entries(event.extendedProps.modal_trigger || {}).forEach(([name, value]) => {
            el.setAttribute(`data-${name}`, value);
          });
        },
        eventMouseEnter(info) {
          $(info.el).attr('title', info.event.title);
        },
        events: `/projects/${projectId}/calendar/xhr_calendar_events`,
        eventClassNames: (info) => {
          const classNames = [];
          if (info.event.extendedProps.is_yesterday === true) {
            classNames.push('fc-event-past');
          }
          if (
            info.event.extendedProps.kind === 'task_event' &&
            info.event.extendedProps.is_completed === true
          ) {
            classNames.push('fc-event-completed');
          }
          return classNames;
        },
        eventTimeFormat: {
          hour: 'numeric',
          minute: '2-digit',
          meridiem: 'short',
        },
        eventDisplay: 'block',
        eventOrder: (event) => {
          return event.kind === 'project_due_date' ? 1 : 0;
        },
        moreLinkContent: (args) => {
          return args.num === 1 ? '+ 1 more item' : `+ ${args.num} more items`;
        },
        eventClick: (info) => {
          info.jsEvent.preventDefault();
          if (info.event.extendedProps.kind === 'project_due_date') {
            return;
          } else if (info.event.extendedProps.kind === 'task_event') {
            window.open(info.event.url);
          } else if (info.event.extendedProps.modal_trigger) {
            $('.fc-popover-close').click();
          }
        },
        eventDrop: (info) => {
          updateDraggedOrResizedEvent(info);
        },
        eventResize: (info) => {
          updateDraggedOrResizedEvent(info);
        },
      });
      calendar.render();
    });
  }

  const roundUpTime = (time) => {
    // A typed value such as "3pm" has no minutes to round.
    if (!/^\d{1,2}:\d{2}/.test(time)) {
      return time;
    }

    const defaultHours = parseInt(time.split(':')[0]);
    const defaultMinutes = parseInt(time.split(':')[1]);
    const meridiem = time.split(':')[1].replace(/\d+/g, '');
    const roundedMinutes = Math.ceil(defaultMinutes / 15) * 15;
    if (roundedMinutes === 0) {
      return time;
    } else {
      return `${defaultHours}:${roundedMinutes}${meridiem}`;
    }
  };

  const initTimepicker = (field) => {
    // round up time only on initial selection
    const defaultTime = field.data('id') ? field.data('time') : roundUpTime(field.val());

    field.timepicker({
      timeFormat: 'h:mmp',
      interval: 15,
      defaultTime,
      startTime: '00:00',
      dynamic: false,
      dropdown: true,
      scrollbar: true,
      change: (time) => {
        $(field).on('click', () => {
          scrollSelectionIntoView(field);
        });

        const startDate = document.getElementById('calendar_event_start_date').datepicker.getDate();

        if (!startDate || field.attr('id') !== 'calendar_event_starts_at_time' || !time) {
          return;
        }

        const eventStartAt = new Date(`${startDate.toDateString()} ${time.toTimeString()}`);
        const thirtyMinutesFromNow = new Date(
          new Date(Date.now() + 1000 * (60 * 30)).toLocaleString('en', {
            timeZone: field.closest('form').attr('data-time-zone'),
          })
        );
        // disable reminder if the event start after the soonest reminder as 30 minutes before
        $('#calendar_event_reminder').prop('disabled', eventStartAt < thirtyMinutesFromNow);
      },
    });
  };

  const scrollSelectionIntoView = (field) => {
    $('.ui-state-hover').removeClass('ui-state-hover');
    // find selected item in the dropdown
    if (!field.val()) {
      return;
    }

    const dropdownSelection = $('.ui-timepicker .ui-menu-item').filter(function () {
      return $(this).text() === roundUpTime(field.val());
    });

    // highlight selected item
    dropdownSelection.find('.ui-corner-all').addClass('ui-state-hover');

    // scroll to selected item
    const index = dropdownSelection.index();
    const height = dropdownSelection.innerHeight();

    $('.ui-timepicker-viewport').scrollTop(index * height);
  };

  const updateDraggedOrResizedEvent = (info) => {
    const { oldEvent, event: updatedEvent } = info;
    const kind = updatedEvent.extendedProps.kind;

    if (kind === 'custom_event' || updatedEvent.allDay) {
      $.ajax({
        url: updatedEvent.extendedProps.update_dragged_or_resized_event_url,
        type: 'PATCH',
        data: { calendar_event: calendarEventParams(kind, oldEvent, updatedEvent) },
      }).done(() => {
        calendar.refetchEvents();
      });
    } else {
      info.revert(); // revert if other than custom event is dragged into hour cell
    }
  };

  const calendarEventParams = (kind, oldEvent, updatedEvent) => {
    if (kind === 'custom_event') {
      return customEventParams(oldEvent, updatedEvent);
    } else if (['project_due_date', 'task_event'].includes(kind)) {
      return { new_due_date: updatedEvent.startStr };
    } else {
      return { old_date: oldEvent.startStr, new_date: updatedEvent.startStr };
    }
  };

  const customEventParams = (oldEvent, updatedEvent) => {
    let endsAt;
    if (oldEvent.allDay) {
      if (updatedEvent.allDay) {
        endsAt = new Date(updatedEvent.end.getTime() - 24 * 60 * 60 * 1000); // subtract one day for exclusive end time
      } else {
        endsAt = new Date(updatedEvent.start.getTime() + 60 * 60 * 1000); // add one hour to start time
      }
    } else {
      endsAt = updatedEvent.allDay ? updatedEvent.startStr : updatedEvent.endStr;
    }
    return {
      starts_at: updatedEvent.startStr,
      ends_at: endsAt,
      all_day: updatedEvent.allDay,
    };
  };
  $(document).on('turbo:frame-load', '#calendar_event_form', (e) => {
    initTimepicker($('#calendar_event_starts_at_time'));
    initTimepicker($('#calendar_event_ends_at_time'));

    // The timepicker appends its one dropdown to body, which the modal dialog makes inert and covers.
    // Inside the dialog's top layer it stays clickable and still positions against the page.
    $.TimePicker.instance().container.attr('popover', 'manual').appendTo(e.target)[0].showPopover();
  });

  $(document).on(
    'turbo:submit-end',
    '#calendar_event_form form, #calendar_event_deletion form',
    (e) => {
      if (e.detail.success) {
        calendar.refetchEvents();
      }
    }
  );

  $(document).on('change', '#calendar_event_start_date', () => {
    $('#calendar_event_starts_at_time').trigger('change');
  });
});
